import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Analytics } from '@vercel/analytics/react';
import './styles/tokens.css';
import './styles/site.css';

const { PUBLIC_URL } = process.env;


const About = lazy(() => import('./pages/About'));
const Contact = lazy(() => import('./pages/Contact'));
const Index = lazy(() => import('./pages/Index'));
const NotFound = lazy(() => import('./pages/NotFound'));
const Projects = lazy(() => import('./pages/Projects'));
const Viz = lazy(() => import('./pages/Viz'));
const Resume = lazy(() => import('./pages/Resume'));
const Stats = lazy(() => import('./pages/Stats'));
const Vinyl = lazy(() => import('./pages/Vinyl'));

const App = () => (
  <BrowserRouter basename={PUBLIC_URL}>
    <Suspense fallback={null}>
      <Routes>
        <Route path="/" element={<Index />} />
        <Route path="/about" element={<About />} />
        <Route path="/projects" element={<Projects />} />
        <Route path="/viz" element={<Viz />} />
        <Route path="/stats" element={<Stats />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/resume" element={<Resume />} />
        <Route path="/vinyl" element={<Vinyl />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </Suspense>
    <Analytics />
  </BrowserRouter>
);

export default App;
